import numeral from "numeral";
// eslint-disable-next-line no-unused-vars
import locales from "numeral/locales"; // NOTE: locales has to be imported this way for it to work

// Optionally override abbreviations
const ptBr = numeral.locales["pt-br"];
ptBr.abbreviations.million = "mi"; // only tweak what you need
numeral.register("locale", "pt-br-custom", ptBr);

// Set locale globally
numeral.locale("pt-br-custom");

export default numeral;
